var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"data-view"}},[_c('dv-full-screen-container',[_c('header-top'),_c('left-main'),_c('right-main'),_c('div',{staticClass:"map"},[_c('Map',{ref:"map"})],1)],1),_c('div',{staticClass:"clear_both"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }